import {FirebaseTopicModel} from "../../firebase-topic-model";
import {IUserTicketsUpdateData} from "./user-tickets-update-topic.model.interface";

export class UserTicketsUpdateTopicModel extends FirebaseTopicModel<IUserTicketsUpdateData, IUserTicketsUpdateData> {
    getTopicName(): string {
        return `CasinoCrmNotification/${this.services.user.cid}`
    }

    getTopicLabel(): string {
        return "CasinoCrmNotification";
    }

    protected _mapRawMessageToPublishMessage(rawMessage: IUserTicketsUpdateData): IUserTicketsUpdateData | null {
        return rawMessage ?? null;
    }
}